import { AppRoutingModule } from './app-routing/app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgModule, CUSTOM_ELEMENTS_SCHEMA   } from '@angular/core';
// import { HttpModule } from '@angular/http'; // Deprecated
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ng2-validation';
import { ModalModule } from 'ngx-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { NgxUploaderModule } from 'ngx-uploader';
import { UiSwitchModule } from 'ngx-toggle-switch';

import { SDKBrowserModule } from '../assets/js/lb-sdk';

import { RecaptchaModule } from 'ng-recaptcha';
import { MyDatePickerModule } from 'mydatepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { CookieService } from 'ngx-cookie-service';


import { AppComponent } from './app.component';
import { TemplatesModule } from './templates/templates.module';

// SERVICES
import { Authentication, ProductsService } from './services';

// import { WindowService } from './services/window.service';

// DIRECTIVES
import { NumberOnlyDirective } from './directives/number.directive';
import { CurrencyOnlyDirective } from './directives/currency.directive';

// COMPONENTS
import { AuthenticationComponent } from './pages/authentication/authentication.component';
import { LoginComponent } from './pages/authentication/login/login.component';
import { LogoutComponent } from './pages/authentication/logout/logout.component';
import { RegisterComponent } from './pages/authentication/register/register.component';
import { RegisterLiteComponent } from './pages/authentication/register/register-lite.component';
import { HomeComponent } from './pages/home/home.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ScannerComponent } from './pages/dashboard/scanner/scanner.component';
import { PartnerVerificationFormComponent } from './pages/authentication/register/partner-verification-form/partner-verification-form.component';
import { PartnerIdentityVerificationFormComponent } from './pages/authentication/register/partner-identity-verification-form/partner-identity-verification-form.component';
import { CredentialFormComponent } from './pages/authentication/register/credential-form/credential-form.component';
import { RegistrationFormComponent } from './pages/authentication/register/registration-form/registration-form.component';
import { NotFoundComponent } from './pages/static/not-found/not-found.component';
import { AccountVerifiedComponent } from './pages/static/account-verified/account-verified.component';
import { StandardDiscountsComponent } from './pages/administration/maintenance/standard-discount/standard-discount.component';
import { AccessDeniedComponent } from './pages/static/access-denied/access-denied.component';
import { NoDataFoundComponent } from './pages/static/no-data-found/no-data-found.component';
import { DeleteModalComponent } from './templates/delete-modal/delete-modal.component';
import { StandardDiscountFormComponent } from './pages/administration/maintenance/standard-discount/standard-discount-form/standard-discount-form.component';
import { ProductImageComponent } from './pages/administration/maintenance/product-image/product-image.component';
import { ProductImageFormComponent } from './pages/administration/maintenance/product-image/product-image-form/product-image-form.component';
import { ProfileComponent } from './pages/authentication/profile/profile.component';
import { ChangeUsernameComponent } from './pages/authentication/change-username/change-username.component';
import { ChangePasswordComponent } from './pages/authentication/change-password/change-password.component';
import { UsersComponent } from './pages/administration/users/users.component';
import { UserFormComponent } from './pages/administration/users/user-form/user-form.component';
import { ApplicationPipesModule } from './pipes/pipes.module';
import { ForgotPasswordComponent } from './pages/authentication/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/authentication/reset-password/reset-password.component';
import { OrderFormComponent } from './pages/agents/orders/order-form/order-form.component';
import { OrderItemComponent } from './pages/agents/orders/order-form/order-item/order-item.component';
import { ProductDetailsComponent } from './pages/agents/product-details/product-details.component';
import { PaymentFormComponent } from './pages/agents/orders/payment-form/payment-form.component';
import { OrdersComponent } from './pages/agents/orders/orders.component';
import { OrderDetailsComponent } from './pages/agents/orders/order-details/order-details.component';
import { ChangeMerchantTypeComponent } from './pages/authentication/change-merchant-type/change-merchant-type.component';
import { ConfigurationComponent } from './pages/administration/configuration/configuration.component';
import { OrderDiscountComponent } from './pages/agents/orders/order-form/order-discount/order-discount.component';
import { ActivationListComponent } from './pages/agents/cards/activation/activation-list.component';
import { PaymentsComponent } from './pages/agents/payments/payments.component';
import { CardsComponent } from './pages/agents/cards/cards.component';
import { CommissionsComponent } from './pages/agents/commissions/commissions.component';
import { BankTransactionsComponent } from './pages/administration/bank-transactions/bank-transactions.component';
import { BankTransactionsFormComponent } from './pages/administration/bank-transactions/bank-transactions-form/bank-transactions-form.component';
import { BankTransactionComponent } from './pages/administration/bank-transactions/bank-transaction/bank-transaction.component';
import { ChangeEmailComponent } from './pages/authentication/change-email/change-email.component';
import { AdminRegistrationComponent } from './pages/administration/users/admin-registration/admin-registration.component';
import { DiscountsComponent } from './pages/agents/discounts/discounts.component';
import { OverPaymentComponent } from './pages/agents/orders/over-payment/over-payment.component';
import { TermsAndConditionsComponent } from './pages/administration/terms-and-conditions/terms-and-conditions.component';
import { TermsAndConditionsFormComponent } from './pages/administration/terms-and-conditions/terms-and-conditions-form/terms-and-conditions-form.component';
import { TermsAndConditionsAcceptComponent } from './pages/administration/terms-and-conditions/terms-and-conditions-accept/terms-and-conditions-accept.component';
import { UserProfileComponent } from './pages/administration/users/user-profile/user-profile.component';
import { CommissionUploadsComponent } from './pages/administration/commission-uploads/commission-uploads.component';
import { CommissionUploadsFormComponent } from './pages/administration/commission-uploads/commission-uploads-form/commission-uploads-form.component';
import { CommissionUploadComponent } from './pages/administration/commission-uploads/commission-upload/commission-upload.component';
import { DiscountRatesComponent } from './pages/administration/maintenance/discount/discount-rates.component';
import { AgentProfileComponent } from './pages/agents/agent-profile/agent-profile.component';
import { DiscountRateFormComponent } from './pages/administration/maintenance/discount/discount-rate-form/discount-rate-form.component';
import { DiscountRequestsComponent } from './pages/administration/maintenance/discount-requests/discount-requests.component';
import { DiscountRequestFormComponent } from './pages/administration/maintenance/discount-requests/discount-request-form/discount-request-form.component';
import { AlreadyVerifiedComponent } from './pages/static/already-verified/already-verified.component';
import { OtherOrdersComponent } from './pages/administration/other-orders/other-orders.component';
import { OtherOrderDetailsComponent } from './pages/administration/other-orders/other-order-details/other-order-details.component';
import { PaymentListComponent } from './pages/administration/payment-list/payment-list.component';
import { VolumeDiscountsComponent } from './pages/administration/maintenance/volume-discounts/volume-discounts.component';
import { VolumeDiscountFormComponent } from './pages/administration/maintenance/volume-discounts/volume-discount-form/volume-discount-form.component';
import { VolumeDiscountRatesComponent } from './pages/administration/maintenance/volume-discount-rates/volume-discount-rates.component';
import { VolumeDiscountRateRequestsComponent } from './pages/administration/maintenance/volume-discount-rate-requests/volume-discount-rate-requests.component';
import { VolumeDiscountRateFormComponent } from './pages/administration/maintenance/volume-discount-rates/volume-discount-rate-form/volume-discount-rate-form.component';
import { VolumeDiscountRateRequestFormComponent } from './pages/administration/maintenance/volume-discount-rate-requests/volume-discount-rate-request-form/volume-discount-rate-request-form.component';
import { OrderVolumeDiscountComponent } from './pages/agents/orders/order-form/order-volume-discount/order-volume-discount.component';
import { AuditTrailsComponent } from './pages/administration/audit-trails/audit-trails.component';
import { AuditTrailsDetailsComponent } from './pages/administration/audit-trails/audit-trails-details/audit-trails-details.component';
import { CronjobsComponent } from './pages/administration/cronjobs/cronjobs.component';
import { DiscountLimitsComponent } from './pages/administration/discount-limits/discount-limits.component';
import { DiscountLimitFormComponent } from './pages/administration/discount-limits/discount-limit-form/discount-limit-form.component';
import { IPay88FormComponent } from './pages/agents/orders/payment-form/ipay88-form/ipay88-form.component';

import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { QRCodeModule } from 'angularx-qrcode';

import { UploadFormComponent } from './v2/administration/payment-list/payment-list-upload/upload-form/upload-form.component';
import { PaymentListUploadComponent } from './v2/administration/payment-list/payment-list-upload/payment-list-upload.component';
import { FaqComponent } from './pages/faq/faq.component';
import { CreditCardCheckComponent } from './pages/agents/orders/payment-form/credit-card-check/credit-card-check.component';
import { ProductsComponent } from './pages/administration/products/products.component';

import { HTTP_INTERCEPTORS, HttpClientXsrfModule } from '@angular/common/http';

import { HttpInterceptor, HttpHandler,HttpXsrfTokenExtractor, HttpEvent, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class CustomInterceptor implements HttpInterceptor {
    constructor(private tokenExtractor: HttpXsrfTokenExtractor) {}
    intercept(req:HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const cookieheaderName = 'X-XSRF-TOKEN';
        let csrfToken = this.tokenExtractor.getToken() as string;
        if (csrfToken !== null && !req.headers.has(cookieheaderName)) {
            req = req.clone({ headers: req.headers.set(cookieheaderName, csrfToken) });
        }
        return next.handle(req);
    }

}
@NgModule({
  declarations: [
    AppComponent,
    AuthenticationComponent,
    LoginComponent,
    RegisterComponent,
    RegisterLiteComponent,
    LogoutComponent,
    HomeComponent,
    NumberOnlyDirective,
    CurrencyOnlyDirective,
    DashboardComponent,
    PartnerVerificationFormComponent,
    PartnerIdentityVerificationFormComponent,
    CredentialFormComponent,
    RegistrationFormComponent,
    NotFoundComponent,
    AccountVerifiedComponent,
    StandardDiscountsComponent,
    AccessDeniedComponent,
    NoDataFoundComponent,
    StandardDiscountFormComponent,
    ProductImageComponent,
    ProductImageFormComponent,
    ProfileComponent,
    ChangeUsernameComponent,
    ChangePasswordComponent,
    UsersComponent,
    UserFormComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    OrderFormComponent,
    OrderItemComponent,
    ProductDetailsComponent,
    IPay88FormComponent,
    PaymentFormComponent,
    OrdersComponent,
    OrderDetailsComponent,
    ChangeMerchantTypeComponent,
    ConfigurationComponent,
    OrderDiscountComponent,
    ActivationListComponent,
    PaymentsComponent,
    CardsComponent,
    CommissionsComponent,
    BankTransactionsComponent,
    BankTransactionsFormComponent,
    BankTransactionComponent,
    AdminRegistrationComponent,
    ChangeEmailComponent,
    DiscountsComponent,
    OverPaymentComponent,
    TermsAndConditionsComponent,
    TermsAndConditionsFormComponent,
    TermsAndConditionsAcceptComponent,
    UserProfileComponent,
    CommissionUploadsComponent,
    CommissionUploadsFormComponent,
    CommissionUploadComponent,
    DiscountRatesComponent,
    AgentProfileComponent,
    DiscountRateFormComponent,
    DiscountRequestsComponent,
    DiscountRequestFormComponent,
    AlreadyVerifiedComponent,
    OtherOrdersComponent,
    OtherOrderDetailsComponent,
    PaymentListComponent,
    VolumeDiscountsComponent,
    VolumeDiscountFormComponent,
    VolumeDiscountRatesComponent,
    VolumeDiscountRateRequestsComponent,
    VolumeDiscountRateFormComponent,
    VolumeDiscountRateRequestFormComponent,
    OrderVolumeDiscountComponent,
    AuditTrailsComponent,
    AuditTrailsDetailsComponent,
    CronjobsComponent,
    DiscountLimitsComponent,
    DiscountLimitFormComponent,
    ScannerComponent,
    UploadFormComponent,
    PaymentListUploadComponent,
    FaqComponent,
    CreditCardCheckComponent,
    ProductsComponent,

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    // HttpModule, // Deprecated
    HttpClientXsrfModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule.forRoot(),
    SDKBrowserModule.forRoot(),
    NgSelectModule,
    MyDatePickerModule,
    TemplatesModule,
    ApplicationPipesModule,
    // RepositoryModule,  ,,
    ModalModule.forRoot(),
    ToastrModule.forRoot(),
    CustomFormsModule,
    NgxUploaderModule,
    UiSwitchModule,
    QRCodeModule,
    ZXingScannerModule
  ],
  providers: [
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: CustomHttpInterceptor,
    //   multi: true
    // },
    ,
    { provide: HTTP_INTERCEPTORS,
      useClass: CustomInterceptor,
      multi: true
    },
    CookieService,
    Authentication,
    ProductsService,
    // WindowService
  ],
  entryComponents: [
    DeleteModalComponent,
    StandardDiscountFormComponent,
    ProductImageFormComponent,
    ChangeUsernameComponent,
    ChangePasswordComponent,
    ChangeEmailComponent,
    ChangeMerchantTypeComponent,
    UserFormComponent,
    ProductDetailsComponent,
    BankTransactionsFormComponent,
    TermsAndConditionsFormComponent,
    TermsAndConditionsAcceptComponent,
    UserProfileComponent,
    CommissionUploadsFormComponent,
    AgentProfileComponent,
    DiscountRateFormComponent,
    DiscountRequestFormComponent,
    VolumeDiscountFormComponent,
    VolumeDiscountRateFormComponent,
    VolumeDiscountRateRequestFormComponent,
    AuditTrailsDetailsComponent,
    DiscountLimitFormComponent,
    UploadFormComponent
  ],
  exports: [],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA // Tells Angular we will have custom tags in our templates
  ]
})
export class AppModule { }
